// extracted by mini-css-extract-plugin
export default {"container":"Table_container__U6vqo","table_type":"Table_table_type__rrFHa"};